import type { ErrorInfo, ReactNode } from 'react';
import { Component, lazy } from 'react';
import { Title } from 'src/components/feedback/error-boundary';
import { AppShellSkeleton } from 'src/components/layout/app-shell/skeleton';
import { MissingMock } from 'src/utils/errors';
import { reportToSentry } from 'src/utils/report-to-sentry';

const UnknownError = lazy(() => import('../../pages/errors/unknown'));

type State = {
  // container is used to handle `throw undefined` easily
  errorContainer?: { error: unknown };
};

export class FatalErrorBoundary extends Component<
  { children?: ReactNode },
  State
> {
  override state: State = { errorContainer: undefined };

  static getDerivedStateFromError(error: unknown) {
    if (error instanceof MissingMock) throw error;
    return { errorContainer: { error } } satisfies State;
  }

  override componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    reportToSentry(error, errorInfo);
  }

  override render() {
    const { errorContainer } = this.state;
    if (errorContainer === undefined) return this.props.children;

    return (
      <AppShellSkeleton>
        <Title>Fatal Error</Title>
        <UnknownError />
      </AppShellSkeleton>
    );
  }
}
